// extracted by mini-css-extract-plugin
module.exports = {"main":"UserManagement_main__2rrd2","search-row":"UserManagement_search-row__2Kpu5","user-actions":"UserManagement_user-actions__1qvTd"};